var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9024 9.87145C19.6817 10.47 19.1351 10.8568 18.5091 10.8568H17.9998V18.3214C17.9998 18.696 17.7011 19 17.3331 19H13.3333V14.2498C13.3333 12.3789 11.8381 10.8568 10.0001 10.8568C8.16222 10.8568 6.66696 12.3789 6.66696 14.2498V19H2.66713C2.29915 19 2.0005 18.696 2.0005 18.3214V10.8568H1.49052C0.864549 10.8568 0.317906 10.4707 0.0972496 9.87213C-0.123407 9.2736 0.0385855 8.61536 0.510564 8.19598L8.29622 0.690647C9.25217 -0.230216 10.7488 -0.230216 11.7041 0.690647L19.5084 8.21362C19.9604 8.61468 20.123 9.27292 19.9024 9.87145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b29c0924b3766564943d389ad1560959.svg";
export { ForwardRef as ReactComponent };